module.exports = __webpack_public_path__ + "img/packages/l5.ad43df.png";